export const MAIL_CLASSIFY_BODY_FIELD = 'body';
export const MAIL_CLASSIFY_OPERATOR_CONTAINS = 'contains';
export const MAIL_CLASSIFY_OPERATOR_EXCLUDES = 'excludes';
export const MAIL_CLASSIFY_OPERATOR_MATCH = 'match';
export const MAIL_CLASSIFY_OPERATOR_UNMATCH = 'unmatch';
export const getDefaultOperatorByField = (field) => (field === MAIL_CLASSIFY_BODY_FIELD ? MAIL_CLASSIFY_OPERATOR_MATCH : MAIL_CLASSIFY_OPERATOR_CONTAINS);
export const normalizeConditionOperatorByField = (field, operator) => {
    if (field === MAIL_CLASSIFY_BODY_FIELD) {
        if (operator === MAIL_CLASSIFY_OPERATOR_CONTAINS) {
            return MAIL_CLASSIFY_OPERATOR_MATCH;
        }
        if (operator === MAIL_CLASSIFY_OPERATOR_EXCLUDES) {
            return MAIL_CLASSIFY_OPERATOR_UNMATCH;
        }
        return operator || MAIL_CLASSIFY_OPERATOR_MATCH;
    }
    if (operator == null) {
        return MAIL_CLASSIFY_OPERATOR_CONTAINS;
    }
    if (operator === MAIL_CLASSIFY_OPERATOR_MATCH) {
        return MAIL_CLASSIFY_OPERATOR_CONTAINS;
    }
    if (operator === MAIL_CLASSIFY_OPERATOR_UNMATCH) {
        return MAIL_CLASSIFY_OPERATOR_EXCLUDES;
    }
    return operator;
};
export const isBodyContainsOperator = (operator) => [MAIL_CLASSIFY_OPERATOR_CONTAINS, MAIL_CLASSIFY_OPERATOR_MATCH].includes(operator || '');
export const isBodyExcludesOperator = (operator) => [MAIL_CLASSIFY_OPERATOR_EXCLUDES, MAIL_CLASSIFY_OPERATOR_UNMATCH].includes(operator || '');
